import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { CATALOG_AVAILABILITY_CONDITION_CONFIGS } from '../../../../../../availabilityConditions.const';
import { Catalog } from '../../../../../../catalog.types';
import CatalogMinimumStockInfo from '../../../../../../components/CatalogMinimumStockInfo';
import CatalogGridCriteriaCard from './components/CatalogGridCriteriaCard';
import useCatalogGridCriteriaSection from './hook/useCatalogGridCriteriaSection';

export type CatalogGridCriteriaSectionProps = Pick<Catalog, 'id' | 'availabilityConditions'> & {
  isReadOnly: boolean;
};

const CatalogGridCriteriaSection = (props: CatalogGridCriteriaSectionProps) => {
  const { availabilityConditions } = props;
  const { isFieldDisabled, validateStockCondition, submitStockCondition } =
    useCatalogGridCriteriaSection(props);

  return (
    <ObjectScreen.Section
      title={LangEnum.GLOBAL_MINIMUM_STOCK}
      info={<CatalogMinimumStockInfo />}
      isDefaultOpen
      persistKey="catalog-details:grid-criteria"
    >
      <Stack sx={{ gap: 2 }}>
        {CATALOG_AVAILABILITY_CONDITION_CONFIGS.map(({ type, labelLang }) => (
          <CatalogGridCriteriaCard
            key={type}
            availability={type}
            labelLang={labelLang}
            conditions={availabilityConditions?.[type]}
            isDisabled={isFieldDisabled}
            validate={validateStockCondition}
            onConfirm={submitStockCondition}
          />
        ))}
      </Stack>
    </ObjectScreen.Section>
  );
};

export default CatalogGridCriteriaSection;
